import styled from 'styled-components'

const WrapAvatar = styled.span`
  margin-left: 5px;
`

export { WrapAvatar }
